import lazyScreen from '../utils/lazyScreen';
const HRWorkingAttendances = lazyScreen(() => import('../pages/timesheet/HRWorkingAttendances/index.js'), 'pages/timesheet/HRWorkingAttendances/index.js');
const HRWorkingAttendanceLogs = lazyScreen(() => import('../pages/timesheet/HRWorkingAttendances/AttendanceLogs.js'), 'pages/timesheet/HRWorkingAttendances/AttendanceLogs.js');
const HRWorkingDay = lazyScreen(() => import('../pages/timesheet/HRWorkingDay/index.js'), 'pages/timesheet/HRWorkingDay/index.js');
const HRWorkingTimesheets = lazyScreen(() => import('../pages/timesheet/HRWorkingTimesheets/index.js'), 'pages/timesheet/HRWorkingTimesheets/index.js');
const RollCalls = lazyScreen(() => import('../pages/timesheet/RollCalls/index.js'), 'pages/timesheet/RollCalls/index.js');
const HROvertimeRequests = lazyScreen(() => import('../pages/timesheet/HROvertimeRequests/index.js'), 'pages/timesheet/HROvertimeRequests/index.js');
const HROvertimeRequest = lazyScreen(() => import('../pages/timesheet/HROvertimeRequest/index.js'), 'pages/timesheet/HROvertimeRequest/index.js');
const HRWorkingTimesheet = lazyScreen(() => import('../pages/timesheet/HRWorkingTimesheet/index.js'), 'pages/timesheet/HRWorkingTimesheet/index.js');

export default [
    { path: '/timesheet/HRWorkingAttendanceLogs', component: HRWorkingAttendanceLogs },
    { path: '/timesheet/RollCalls', component: RollCalls },
    { path: '/timesheet/HROvertimeRequests', component: HROvertimeRequests },
    { path: '/timesheet/HROvertimeRequest/:code', component: HROvertimeRequest },
    { path: '/timesheet/HRWorkingDay/:code', component: HRWorkingDay },
    { path: '/timesheet/HRWorkingTimesheet/:id', component: HRWorkingTimesheet },
    {
        path: '/timesheet/HRWorkingAttendances',
        component: HRWorkingAttendances
    },
    {
        path: '/timesheet/HRWorkingTimesheets',
        component: HRWorkingTimesheets
    }
];
